// Feature switches. David (AI assistant widget + welcome popup) is paused —
// the WhatsApp chat line replaces it on every page.
export const DAVID_ENABLED = false;
